import React from 'react';
import '../styles.css';

export default function About() {
  return (
    <section className="about">
      <h2>About Us</h2>
      <p>
        <strong>Founded 2024</strong> by photographers, engineers, and AI researchers in San Francisco, CA.
      </p>
      <p className="about__mission">
        <strong>Mission:</strong> Make photo-sharing effortless and magical for families.
      </p>
    </section>
  );
}
